<template>
  <div id="SectionEcovadisFAQ">
    <UIContainer class="SectionEcovadisFAQ__container">
      <template #left>
        <SectionTitle>
          <template #title>FAQs</template>
          <template #description>
            Have more questions about EcoVadis? Can’t find the answer you’re
            looking for? Please
            <UIButtonText
              class="SectionEcovadisFAQ__support-link"
              :to="{ name: 'Contact' }"
            >
              contact our support team.
            </UIButtonText>
          </template>
        </SectionTitle>
      </template>

      <template #right>
        <UIFaqs :faqs="faqs" />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButtonText from '@/views/components/ui/buttons/UIButtonText.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIFaqs from '@/views/components/features/faqs/UIFaqs.vue'

const faqs = [
  {
    question: 'What is Ecovadis?',
    answer:
      'EcoVadis is a sustainability rating platform that evaluates environmental, social, and ethical performance of companies, especially SMEs, using globally recognized standards.',
  },
  {
    question: 'What are the benefits of net zero software?',
    answer:
      'EcoVadis helps companies improve their sustainability performance, access new markets, and build trust with stakeholders by providing a transparent and objective assessment of their sustainability practices.',
  },
  {
    question:
      'How does Sustainalyse Carbon Management Platform help companies reduce their emissions?',
    answer:
      'EcoVadis helps companies improve their sustainability performance, access new markets, and build trust with stakeholders by providing a transparent and objective assessment of their sustainability practices.',
  },
  {
    question: 'What are the main features of net zero software?',
    answer:
      'EcoVadis provides a comprehensive assessment of sustainability performance across four pillars: Environment, Labor and Human Rights, Ethics, and Sustainable Procurement. It also offers sector-specific questionnaires and provides a scorecard and detailed report to help companies improve their sustainability practices.',
  },
  {
    question: 'Why is net zero important for companies?',
    answer:
      'EcoVadis helps companies improve their sustainability performance, access new markets, and build trust with stakeholders by providing a transparent and objective assessment of their sustainability practices.',
  },
]
</script>

<style lang="scss" scoped>
#SectionEcovadisFAQ {
  .SectionEcovadisFAQ__container {
    background-color: $color-white;
    :deep(.UIContainer__grid) {
      display: flex;
      flex-direction: column;
      align-items: stretch;

      @include md {
        flex-direction: row;
        align-items: normal;
      }

      .UIContainer__left {
        width: 100%;
        @include md {
          width: 40%;
          padding-right: 3rem;
        }
      }
      .UIContainer__right {
        width: 100%;
        margin-top: 1rem;
        @include md {
          width: 60%;
          margin-top: 0;
        }
      }
    }
  }

  .SectionEcovadisFAQ__support-link {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
